'use client';

import React, { useState } from 'react';
import { useChatbotSafe } from './chatbot-provider';
import { cn } from '../../utilities/classname';

export const ChatbotInlineInput: React.FC<{
  placeholder?: string;
  buttonText?: string;
  className?: string;
}> = ({
  placeholder = 'What are you looking for?',
  buttonText = 'Ask',
  className,
}) => {
  const chatbot = useChatbotSafe();
  const [value, setValue] = useState('');

  // If chatbot provider is not mounted (chatbot disabled), render nothing
  if (!chatbot) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!value.trim()) return;
    chatbot.open(value.trim());
    setValue('');
  };

  return (
    <form onSubmit={handleSubmit} className={cn('join', className)}>
      <input
        type="text"
        className="input join-item grow"
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
      <button type="submit" className="btn btn-primary join-item">
        {buttonText}
      </button>
    </form>
  );
};
